module.exports = __webpack_public_path__ + "img/isacibanner.7b88837c.jpg";